/** Redirect stale chat links into the in-game drawer. */

import React from 'react'
import { Redirect, useLocalSearchParams } from 'expo-router'

export default function LegacyGameChatRedirect() {
  const { id, focus } = useLocalSearchParams<{
    id: string
    focus?: string | string[]
  }>()
  const focusMessageId = Array.isArray(focus) ? focus[0] : focus
  const chatParam = focusMessageId || '1'
  return (
    <Redirect
      href={`/(app)/games/${encodeURIComponent(id ?? '')}?chat=${encodeURIComponent(chatParam)}` as never}
    />
  )
}
